import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressSpinner } from 'primereact/progressspinner';
import './SpinnerOverlay.scss';
const SpinnerOverlay = () => {
    return (_jsx("div", { className: "progress-spinner-container", children: _jsx(ProgressSpinner, { style: { marginLeft: '90px' } }) }));
};
export default SpinnerOverlay;
